module.exports = __webpack_public_path__ + "img/icon-open-popup-white.1954d663.svg";